export { _assert as default } from 'miragejs';